export const achievements = [
    {
        code: 'premier_pas',
        icon: '🚚',
        title: 'Premier pas',
        description: 'Première livraison marquée préparée',
        points: 10,
    },
    {
        code: 'habitue_route',
        icon: '🛣️',
        title: 'Habitué de la route',
        description: '100 livraisons effectuées',
        points: 50,
    },
    {
        code: 'roi_route',
        icon: '🏆',
        title: 'Roi de la route',
        description: '1000 livraisons effectuées',
        points: 200,
    },
    {
        code: 'semaine_parfaite',
        icon: '📅',
        title: 'Semaine parfaite',
        description: 'Aucune annulation sur une semaine',
        points: 75,
    },
    {
        code: 'createure_nuit',
        icon: '🌙',
        title: 'Créature de la nuit',
        description: 'Mode sombre activé',
        points: 15,
    },
    {
        code: 'strategiste',
        icon: '🗺️',
        title: 'Stratège',
        description: '10 trajets optimisés',
        points: 40,
    },
    {
        code: 'specialiste_immuno',
        icon: '⭐',
        title: 'Spécialiste immuno',
        description: '50 livraisons immuno réalisées',
        points: 60,
    },
    {
        code: 'pilier_equipe',
        icon: '👥',
        title: 'Pilier de l\'équipe',
        description: '1 an d\'ancienneté sur l\'app',
        points: 100,
    },
    {
        code: 'noctambule',
        icon: '🦉',
        title: 'Noctambule',
        description: 'Utiliser l\'app entre minuit et 5h du matin',
        points: 30,
    },
    {
        code: 'lundi_blues',
        icon: '😩',
        title: 'Lundi Blues',
        description: 'Ouvrir l\'app un lundi avant 7h',
        points: 20,
    },
    {
        code: 'cartographe',
        icon: '🗺️',
        title: 'Cartographe',
        description: 'Ouvrir la carte patients 10 fois',
        points: 25,
    },
    {
        code: 'matinal',
        icon: '🌅',
        title: 'Lève-tôt',
        description: 'Utiliser l\'app avant 6h du matin',
        points: 30,
    },
    {
        code: 'vendredi',
        icon: '🎉',
        title: 'TGIF',
        description: 'Utiliser l\'app un vendredi',
        points: 10,
    },
    {
        code: 'perfectionniste',
        icon: '🔍',
        title: 'Perfectionniste',
        description: 'Modifier la même livraison 3 fois de suite',
        points: 35,
    },
    {
        code: 'indecis',
        icon: '🤔',
        title: 'L\'indécis',
        description: 'Changer le statut d\'une livraison 5 fois de suite',
        points: 20,
    },
    {
        code: 'weekend_warrior',
        icon: '🏖️',
        title: 'Week-end warrior',
        description: 'Se connecter un samedi ou dimanche',
        points: 25,
    },
    {
        code: 'marathon',
        icon: '🏃',
        title: 'Marathon',
        description: 'Rester connecté plus de 2h',
        points: 30,
    },
    {
        code: 'explorateur',
        icon: '🧭',
        title: 'Explorateur',
        description: 'Visiter toutes les pages de l\'app',
        points: 35,
    },
    {
        code: 'social',
        icon: '🤝',
        title: 'Social',
        description: 'Voir les hauts faits de 3 collègues',
        points: 20,
    },
    {
        code: 'cafe_virtuel',
        icon: '☕',
        title: 'Café virtuel',
        description: 'Se connecter entre 9h et 9h20 du matin',
        points: 15,
    },
    {
        code: 'signaleur',
        icon: '🐛',
        title: 'Signaleur',
        description: 'Signaler un bug via le bouton dédié',
        points: 20,
    },
    {
        code: 'statisticien',
        icon: '📊',
        title: 'Statisticien',
        description: 'Ouvrir la page statistiques 10 fois',
        points: 25,
    },
    {
        code: 'fidele',
        icon: '🔒',
        title: 'Fidèle',
        description: 'Se connecter 5 jours de suite',
        points: 40,
    },
    {
        code: 'architecte',
        icon: '🏗️',
        title: 'Architecte',
        description: 'Réduire et rouvrir la sidebar 10 fois',
        points: 15,
    },
    {
        code: 'nuit_noel',
        icon: '🎄',
        title: 'Nuit de Noël',
        description: 'Se connecter le 24 ou 25 décembre',
        points: 50,
    },
    {
        code: 'poisson_avril',
        icon: '🐟',
        title: 'Poisson d\'avril',
        description: 'Se connecter le 1er avril',
        points: 30,
    },
    {
        code: 'bonne_annee',
        icon: '🎆',
        title: 'Bonne année !',
        description: 'Se connecter le 1er janvier',
        points: 40,
    },
    {
        code: 'chasseur_fantomes',
        icon: '👻',
        title: 'Chasseur de fantômes',
        description: 'Ouvrir une livraison annulée',
        points: 20,
    },
    {
        code: 'minimaliste',
        icon: '🔲',
        title: 'Minimaliste',
        description: 'Utiliser l\'app en sidebar réduite pendant 10 minutes',
        points: 25,
    },
    {
        code: 'indecis_calendrier',
        icon: '📅',
        title: 'Indécis du calendrier',
        description: 'Naviguer 20 fois entre les semaines',
        points: 20,
    },
    {
        code: 'petit_curieux',
        icon: '🧐',
        title: 'Petit curieux',
        description: 'Jeter un œil au planning d\'une autre agence',
        points: 15,
    },
    {
        code: 'aigle_royal_en_pause',
        icon: '🦅',
        title: 'Aigle royal en pause',
        description: 'Cliquer sur « Masquer pause »… pour enfin voir ce qui se cachait',
        points: 15,
    },
];